<template>
  <patient-profile>
    <modal-dialog-prevent-leave
      v-bind:is-shown="isShownDialogLeaveConfirm"
      v-on:back="isShownDialogLeaveConfirm = false"
      v-on:leave="leaveWithoutSave"
      v-on:save="saveAndLeave" />
    <modal-dialog
      content-class="patient-refusal-modal"
      title="Пациент подписал отказ?"
      v-bind:value="shownEgiszDataRefusalDialog"
      v-on:input="closeEgiszDataRefusalDialog(false)"
      with-cross>
      <p>
        Отказ от передачи данных в&nbsp;ЕГИСЗ без&nbsp;подписи бумажной версии будет недействителен.
      </p>
      <div class="modal-dialog__buttons">
        <button
          type="button"
          class="modal-dialog__cancel"
          v-on:click="closeEgiszDataRefusalDialog(false)">
          Нет
        </button>
        <button
          type="button"
          class="modal-dialog__agree"
          v-on:click="closeEgiszDataRefusalDialog(true)">
          Да
        </button>
      </div>
    </modal-dialog>
    <iframe
      class="patient-print"
      ref="printView"
      title="printView" />
    <article
      class="patient-iemk-status"
      v-bind:class="iemkStatus"
      v-if="false"
    >
      {{ iemkStatusDescription }}
    </article>
    <form
      ref="patientFormRef"
      v-on:submit.prevent=""
    >
      <patient-section-control
        class="patient-basic__sections"
        v-model="sectionVisibly"
        v-if="isSectionLoaded"
      >
        <section class="patient-basic__medical-card">
          <div class="patient-basic__medical-card__row">
            <p v-if="medcard.medicalCardNumber && cardCreatedAt">
              Медицинская карта пациента
              <span> №{{ medcard.medicalCardNumber }}</span>
              <span> от&nbsp;{{ cardCreatedAt }}</span>
            </p>
            <p v-else-if="medcard.medicalCardNumber">
              Медицинская карта пациента
              <span> №{{ medcard.medicalCardNumber }}</span>
            </p>
            <p v-else>Медицинская карта пациента еще не создана</p>
            <button
              title="Редактировать"
              type="button"
              class="patient-basic__medical-card__info-edit"
              v-on:click="openEditForm()" />
          </div>
          <div class="patient-basic__medical-card__info">
            <patient-labels v-bind:labels="medcard.labels" />
          </div>
          <available-section section="patient-contacts">
            <button
              type="button"
              v-on:click="showDialogGuardian = true"
              class="patient-basic__medical-card__member"
            >
              <span v-if="!guardian.id"> + Добавить представителя</span>
              <span v-else>
                {{ guardian.fullName }} ({{ guardian.fullGuardianRelation }})
                <span
                  class="patient-basic__mark-alert"
                  v-if="hasGuardianErrors"
                >!</span>
              </span>
            </button>
          </available-section>
          <div
            v-if="medcard.note"
            class="patient-basic__medical-card__info"
          >
            <div class="patient-basic__medical-card__note">Примечание: {{ medcard.note }}</div>
          </div>
        </section>
        <available-section section="patient-contacts">
          <modal-dialog
            title="Законный представитель"
            v-model="showDialogGuardian"
            with-cross
          >
            <form
              class="patient-basic__representative"
              ref="patientGuardianFormRef"
              v-if="showDialogGuardian"
              v-on:submit.prevent
            >
              <v-autocomplete
                label="ФИО пациента"
                item-value="value"
                item-text="name"
                :items="patients"
                @change="onGuardianSelected"
              >
                <template v-slot:no-data>
                  <div class="px-4">Нет совпадений</div>
                </template>
              </v-autocomplete>
              <div class="patient-basic__representative__row fio">
                <input-text
                  title="Фамилия"
                  v-model="guardian.surname"
                  v-bind:violations="guardianSurnameError"
                  v-letter-capital
                />
                <input-text
                  title="Имя"
                  v-model="guardian.name"
                  v-bind:violations="guardianNameError"
                  v-letter-capital
                />
                <input-text
                  title="Отчество"
                  v-model="guardian.patronymic"
                  v-bind:violations="guardianPatronymicError"
                  v-letter-capital
                />
                <input-date
                  label="Дата рождения"
                  v-bind:violations="guardianBirthDateError"
                  v-model="guardian.birthDate" />
              </div>
              <div class="patient-basic__representative__gender">
                <span>Пол</span>
                <label class="patient-basic__representative__radio">
                  <input
                    v-model="guardian.gender"
                    name="guardianGender"
                    type="radio"
                    v-bind:value="$options.sexNone">
                  <span>Не указано</span>
                </label>
                <label class="patient-basic__representative__radio">
                  <input
                    v-model="guardian.gender"
                    name="guardianGender"
                    type="radio"
                    v-bind:value="$options.sexMale">
                  <span>Мужской</span>
                </label>
                <label class="patient-basic__representative__radio">
                  <input
                    v-model="guardian.gender"
                    name="guardianGender"
                    type="radio"
                    v-bind:value="$options.sexFemale">
                  <span>Женский</span>
                </label>
              </div>
              <the-select
                class="patient-basic__representative__block"
                option-title-key="name"
                option-value-key="name"
                placeholder="Выбрать отношение"
                title="Отношение к пациенту"
                v-bind:options="$options.attitudesToPatient"
                v-bind:violations="guardianRelationError"
                v-model="guardian.relation"
              />
              <input-text
                title="Документ на право представлять пациента"
                class="patient-basic__representative__block"
                v-model="guardian.document"
                v-bind:violations="guardianRepresentDocumentError"
              />
              <input-snils
                class="patient-basic__representative__block"
                v-model="guardian.identification.snils"
                v-bind:optional="true"
                v-bind:violations="guardianSnilsInputError"
              />
              <input-typed-phone
                class="patient-basic__representative__block"
                v-on:input="onInputGuardianPhone"
                v-bind:violations="guardianPhoneInputError"
                v-bind:type="guardian.phone.type"
                v-bind:value="guardian.phone.number"
              />
              <div class="patient-basic__representative__identification-form">
                <form-identification
                  v-on:on-model-update="onUpdateGuardianIdentification"
                  :input-errors="inputErrors"
                  :init-identification="guardian.identification"
                  :is-show-inn="true"
                >
                  <template v-slot:unit-code>
                    <input-text
                      title="Код подразделения"
                      v-mask="`###-###`"
                      v-model="guardian.identification.departmentCode"
                      v-bind:violations="guardianDepartmentCodeInputError"
                    />
                  </template>
                </form-identification>
              </div>
              <button
                type="button"
                class="patient-basic__medical-card__button-save"
                v-bind:disabled="isSaveDisabled"
                v-on:click="onSavePatientGuardian"
              >
                Сохранить
              </button>
              <modal-dialog
                v-if="showDeleteGuardianButton"
                title="Вы действительно хотите удалить законного представителя?"
                v-model="shownConfirmDialogDeleteGuardian"
                with-cross
              >
                <template v-slot:trigger="{ listenerObject }">
                  <button
                    type="button"
                    v-on="listenerObject"
                    class="patient-basic__representative__button"
                  >
                    Удалить представителя
                  </button>
                </template>
                <div class="patient-basic__representative__modal__buttons">
                  <button
                    class="patient-basic__representative__modal__button"
                    type="button"
                    v-on:click="shownConfirmDialogDeleteGuardian = false">Нет</button>
                  <button
                    class="patient-basic__representative__modal__button negative"
                    type="button"
                    v-on:click="onDeleteGuardian">Да</button>
                </div>
              </modal-dialog>
            </form>
          </modal-dialog>
          <patient-section
            label="Контакты"
            ref="patientSectionOfContacts"
            v-if="isShowContact"
          >
            <form-patient-contacts
              v-bind:can-initiate-call="canInitiateCall"
              v-bind:value="contacts"
              v-bind:violation-causes="contactsViolationCauses"
              v-on:initiate-call="onInitiateCallByPatient(patientId, $event)"
              v-on:input="onInputContacts"
              v-on:invalid="highlightInvalidFieldsIntoContactSection"
            />
          </patient-section>
          <patient-section
            ref="patientSectionOfDocuments"
            label="Документы"
          >
            <div class="patient-basic__documents">
              <form-identification
                v-on:on-model-update="onUpdateIdentification"
                :input-errors="inputErrorsIdentification"
                :init-identification="identification"
                :is-show-inn="true"
              >
                <template v-slot:unit-code>
                  <input-text
                    title="Код подразделения"
                    v-mask="`###-###`"
                    v-model="identification.departmentCode"
                    v-bind:violations="departmentCodeInputError"
                  />
                </template>
              </form-identification>
            </div>
          </patient-section>
          <patient-section
            ref="patientSectionOfEgisz"
            label="ЕГИСЗ"
            v-if="shownEgiszSection"
          >
            <div class="patient-basic__documents">
              <input-snils
                class="patient-basic__documents-snils"
                v-bind:optional="!snilsRequired"
                v-bind:violations="snilsInputError"
                v-model="documents.snils"
                v-on:invalid="highlightInvalidFieldsIntoEgiszSection" />
            </div>
          </patient-section>
          <input-checkbox
            v-if="hasEgisz"
            title="Отказ от передачи данных в ЕГИСЗ"
            v-model="individualData.hasEgiszDataRefusal"
            v-on:input="onChangeEgiszDataRefusal" />
          <div class="patient-basic__medical-card__buttons">
            <button
              type="button"
              class="patient-basic__medical-card__button-save"
              v-bind:disabled="isSaveDisabled"
              v-on:click="onSavePatient"
            >
              Сохранить
            </button>
            <popover-menu
              offset-y
              top
              v-bind:close-on-content-click="false"
              v-model="isShownPrintDialog"
            >
              <form
                class="print-medcard-form"
                v-on:submit.prevent="printMedcard"
              >
                <div
                  class="print-medcard-form__document"
                  v-for="format in $options.formatsPrint"
                  v-bind:key="format.value"
                >
                  <label class="print-medcard-form__document__count">
                    <input
                      aria-label="Формат печати"
                      type="radio"
                      v-bind:value="format.value"
                      v-model="formatPrint"
                    />
                    <span> {{ format.title }} </span>
                  </label>
                </div>
                <button
                  v-if="!isMobile"
                  v-bind:disabled="isAwaitRequest"
                  type="submit"
                  class="print-medcard-form__button"
                >Печать</button>
              </form>
              <template v-slot:trigger="{ listenerObject }">
                <button
                  v-if="!isMobile"
                  class="patient-basic__medical-card__button-print"
                  v-bind:disabled="isAwaitRequest"
                  type="button"
                  v-on="listenerObject"
                >Печать</button>
              </template>
            </popover-menu>
          </div>
        </available-section>
      </patient-section-control>
    </form>
    <side-slide-transition>
      <confirm-side-dialog
        label="Медкарта пациента"
        v-bind:need-confirm="needConfirmBeforeClosed"
        v-if="hasOpenForm"
        v-on:cancel="hasOpenForm = false">
        <form-patient-medcard-edit
          v-bind:default-medcard-number="defaultMedcardNumber"
          v-bind:input-errors="medcardInputErrors"
          v-bind:labels="labels"
          v-bind:medcard="medcard"
          v-on:cancel="hasOpenForm = false"
          v-on:change-values="onChangeFieldValues"
          v-on:submit="onChangeMedcard" />
      </confirm-side-dialog>
    </side-slide-transition>
  </patient-profile>
</template>

<script>
import AvailableSection from '@/views/ClinicPanel/AvailableSection.vue';
import { Maybe, Validation } from 'monet';
import debounce from 'lodash.debounce';
import FormPatientContacts, { PatientContacts } from '@/components/FormPatientContacts.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import InputDate from '@/components/InputDate.vue';
import InputSnils from '@/components/InputSnils.vue';
import InputText from '@/components/InputText.vue';
import PatientSection, { PatientSectionControl } from '@/components/PatientSection.vue';
import {
  Address,
  Documents,
  EditAddressRequest,
  EditPatientContactsRequest,
  EditPatientDocumentsRequest,
  EditPatientIdentificationRequest,
  EditPatientMedcardRequest,
  EditPatientIndividualDataRequest,
  Guardian,
  Identification,
  IndividualData,
  Medcard, EditPatientIdentificationForeignPasswordRequest, Phone,
} from '@/storage/gateways/PatientGateway';
import notifierMixin from '@/mixins/notifierMixin';
import { formatDate } from '@/utils/timeFormat';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import FormPatientMedcardEdit from '@/components/FormPatientMedcardEdit.vue';
import { PATIENT_PROFILE } from '@/store/actions/patient';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';
import ModalDialogPreventLeave from '@/components/ModalDialogPreventLeave.vue';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import TheSelect from '@/components/TheSelect.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import callMixin from '@/mixins/callMixin';
import PatientLabels from '@/components/PatientLabels.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import mobileMixin from '@/mixins/mobileMixin';
import FormIdentification from '@/components/FormIdentification.vue';
import InputTypedPhone from '@/components/InputTypedPhone.vue';
import PopoverMenu from '@/components/PopoverMenu.vue';
import { GOAL_PRINT_MEDCART_A5 } from '@/plugins/metric';

const WAIT_TIME = 300;

/**
 * @description Действие инициирование звонков.
 * @type {string}
 */
const ACTION_INITIATE_CALLS = 'initiate-calls';

/**
 * @description допустимые отношения к пациенту
 */
const attitudesToPatient = [
  { name: 'Отсутствует' },
  { name: 'Родитель' },
  { name: 'Сын' },
  { name: 'Дочь' },
  { name: 'Усыновитель' },
  { name: 'Опекун (физическое лицо)' },
  { name: 'Опекун (представитель учреждения социальной опеки)' },
  { name: 'Попечитель' },
  { name: 'Супруг/Супруга' },
];

/**
 * @description Форматы печати.
 */
const formatsPrint = [
  {
    title: 'A5',
    value: 'A5',
  },
  {
    title: 'A4',
    value: 'A4',
  },
];
/**
 * @description допустимые типы документов
 * @type {[{name: string, id: number}]}
 */
const documentTypes = [
  {
    id: 14,
    name: 'Паспорт гражданина РФ',
  },
];

/**
 * @description Миксин для Законного представителя пациента
 */
const GuardianMixin = {
  sexMale: 1,
  sexFemale: 2,
  sexNone: 3,
  computed: {
    showDeleteGuardianButton({ guardian }) {
      return !!guardian.id;
    },
  },
  data() {
    return {
      /**
       * @description Есть ошибки заполнения.
       * @type {boolean}
       */
      hasGuardianErrors: false,
      /**
       * Пациенты для быстрого выбора
       * @type {boolean}
       */
      patients: [],
      guardian: new Guardian(),
      guardians: [],
      isGuardianChanged: false,
      /**
       * @description Показывать диалог подтверждения удаления законного представителя.
       * @type {boolean}
       */
      shownConfirmDialogDeleteGuardian: false,
      /**
       * @description Показывать диалоговое окно законного представителя.
       * @type {boolean}
       */
      showDialogGuardian: false,
    };
  },
  methods: {
    /**
     * @description Обработать события выбора номера телефона
     *
     * @param {object} newValue
     *
     * @return {void}
     */
    onInputGuardianPhone(newValue) {
      const { value, type } = newValue;
      this.guardian.phone.number = value;
      this.guardian.phone.type = type;
    },
    /**
     * Обработать событие обновления личного удостоверения представителя
     *
     * @param newValue
     */
    onUpdateGuardianIdentification(newValue) {
      this.guardian.identification = newValue;
    },
    /**
     * Представитель пациента был выбран
     *
     * @param item
     * @returns {void}
     */
    onGuardianSelected(item) {
      const phone = new Phone(
        item.phone,
        item.phoneType,
      );
      this.guardian = new Guardian(
        item.birthDate,
        '',
        item.identification,
        item.firstName,
        item.patronymic,
        '',
        item.sexId,
        item.lastName,
        null,
        false,
        phone,
      );
    },
    /**
     * Затянуть список представителей
     *
     * @param {Number} patientId
     * @returns {Promise<void>}
     */
    async fetchGuardiansList(patientId) {
      this.patients = await this
        .$patientGateway
        .getGuardiansList(patientId);
    },
    /**
     * @description Удалить представителя пациента
     * @return {Promise<void>}
     */
    async onDeleteGuardian() {
      const guardianId = this.guardian.id;
      const result = await this.$patientGateway.deleteGuardian(guardianId);
      result.forEach((message) => {
        this.shownConfirmDialogDeleteGuardian = false;
        this.guardian = new Guardian();
        this.guardian.refresh();
        this.isGuardianChanged = false;
        this.notifySuccess(message);
        this.guardians = this.guardians.filter((item) => item !== guardianId);
      });
    },
    /**
     * @description Отправить запрос на редактирование представителя пациента
     * @return {Promise<Validation>}
     */
    async sendGuardianEditRequest() {
      const request = this.guardian.createRequest(this.patientId);
      const result = await this.$patientGateway.editGuardian(request);
      result.forEach(({ guardianId }) => {
        this.guardian.id = guardianId;
        if (!this.guardians.find((id) => id === guardianId)) {
          this.guardians.push(guardianId);
        }
        this.guardian.isNew = false;
        this.guardian.refresh();
        this.isGuardianChanged = false;
        this.showDialogGuardian = false;
        this.getFirstGuardian();
      });
      result.forEachFail((response) => {
        if (response.causes.length !== 0) {
          this.showDialogGuardian = true;
        }
      });
      return result;
    },
    /**
     * @description Получить и установить в качестве выбранного первого представителя пациента
     * @return {Promise<void>}
     */
    async getFirstGuardian() {
      if (!this.guardians.length) {
        return;
      }
      const guardianId = this.guardians[0];
      const result = await this.$patientGateway.viewGuardian(guardianId);
      result.forEach(({ errors = {} }) => {
        const causesEntries = (errors.causes || [])
          .map((cause) => [cause.source, cause.details]);
        this.hasGuardianErrors = causesEntries.length !== 0;
        Object.assign(
          this.inputErrors,
          Object.fromEntries(causesEntries),
        );
      });
      result.map((guardian) => {
        const identification = new Identification(
          guardian.identification.address,
          guardian.identification.number,
          guardian.identification.serial,
          guardian.identification.type,
          guardian.identification.when_issued,
          guardian.identification.who_issued,
          guardian.identification.department_code,
          guardian.identification.inn,
          guardian.identification.living_address,
          guardian.identification.snils,
        );
        const phone = new Phone(
          guardian.phone,
          guardian.phone_type,
        );
        return new Guardian(
          guardian.birth_date,
          guardian.represent_document,
          identification,
          guardian.name,
          guardian.patronymic,
          guardian.relation,
          guardian.gender,
          guardian.surname,
          guardian.id,
          false,
          phone,
        );
      })
        .forEach((guardian) => {
          this.guardian = guardian;
        });
    },
  },
  watch: {
    guardian: {
      handler: debounce(function update(value) {
        this.isGuardianChanged = value.isChanged();
      }, WAIT_TIME),
      deep: true,
    },
  },
  attitudesToPatient,
  documentTypes,
};

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Миксин для раздела "личные данные"
 */
const individualDataMixin = {
  data() {
    return {
      individualData: new IndividualData(),
      isEgiszDataRefusalChanged: false,
      isIndividualDataChanged: false,
      shownEgiszDataRefusalDialog: false,
      egiszDataRefusalSampleDocumentTemplateId: null,
    };
  },
  methods: {
    /**
     * @description Закрепить за пациентом шаблон документа по образцу.
     * @returns {void}
     */
    addPatientTemplateBySample() {
      this
        .$documentTemplateGateway
        .addPatientTemplateBySample(
          this.patientId,
          this.egiszDataRefusalSampleDocumentTemplateId,
          'document',
        );
    },
    /**
     * @description Закрыть диалоговое окно отказа от передачи данных в ЕГИСЗ.
     * @param {boolean} hasEgiszDataRefusal
     * @returns {void}
     */
    closeEgiszDataRefusalDialog(hasEgiszDataRefusal) {
      this.shownEgiszDataRefusalDialog = false;
      this.individualData.hasEgiszDataRefusal = hasEgiszDataRefusal;
      if (hasEgiszDataRefusal) {
        this.sendEditPatientIndividualDataRequest()
          .then(() => {
            this.addPatientTemplateBySample();
          });
      }
    },
    /**
     * @description Обработать изменение значение "отказ от передачи в егисз"
     * @param {boolean} hasEgiszDataRefusal
     * @returns {void}
     */
    onChangeEgiszDataRefusal(hasEgiszDataRefusal) {
      this.shownEgiszDataRefusalDialog = hasEgiszDataRefusal;
    },
    /**
     * @description Печать документа отказа от передачи данных в ЕГИСЗ.
     * @returns {void}
     */
    async printEgiszDataRefusalDocument() {
      if (!this.egiszDataRefusalSampleDocumentTemplateId) {
        this.notifyFail('Отсутствует шаблон документа "Отказ от передачи данных в ЕГИСЗ"');
        return;
      }
      const result = await this
        .$patientGateway
        .generateSampleDocumentForPrint(
          this.egiszDataRefusalSampleDocumentTemplateId,
          this.patientId,
        );
      result.forEach((response) => {
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(response));
        container.onload = () => {
          container.contentWindow.print();
        };
      });
    },
    /**
     * @description Отправить запрос на редактирование личных данных пациента
     * @return {Promise<*>}
     */
    async sendEditPatientIndividualDataRequest() {
      const request = new EditPatientIndividualDataRequest(this.individualData, this.patientId);
      const result = await this.$patientGateway.editIndividualData(request);
      result.forEach(() => {
        this.individualData.refresh();
        this.isEgiszDataRefusalChanged = false;
        this.isIndividualDataChanged = false;
      });
      return result;
    },
  },
  watch: {
    individualData: {
      handler: debounce(function update(value) {
        this.isEgiszDataRefusalChanged = value.isEgiszDataRefusalChanged();
        this.isIndividualDataChanged = value.isChanged();
      }, WAIT_TIME),
      deep: true,
    },
  },
};

/**
 * @description Группы крови.
 * @type {{id:number,name:string}[]}
 */
const bloodTypes = [
  { id: 1, name: 'Первая (I)' },
  { id: 2, name: 'Вторая (II)' },
  { id: 3, name: 'Третья (III)' },
  { id: 4, name: 'Четвертая (IV)' },
];

/**
 * @description Типы инвалидности.
 * @type {{id:string,name:string}[]}
 */
const disabilityTypes = [
  { id: 'Отсутствует', name: 'Отсутствует' },
  { id: 'Первая (I)', name: 'Первая (I)' },
  { id: 'Вторая (II)', name: 'Вторая (II)' },
  { id: 'Третья (III)', name: 'Третья (III)' },
];

/**
 * @description Резус фактор.
 * @type {{id:number,name:string}[]}
 */
const rpFactors = [
  { id: 0, name: 'Отрицательный (-)' },
  { id: 1, name: 'Положительный (+)' },
];
/**
 * @description Список диагнозов.
 * @type {{name:string, description:string}[]}
 */
const diagnosisList = [
  { name: '', description: 'выберите значение' },
  { name: '0', description: '0 - отсутствует' },
  { name: 'П', description: 'П - пломбированный' },
  { name: 'R', description: 'R - корень' },
  { name: 'А', description: 'А - пародонтоз' },
  { name: 'C', description: 'C - кариес' },
  { name: 'К', description: 'К - коронка' },
  { name: 'P', description: 'P - пульпит' },
  { name: 'I', description: 'I степень подвижности' },
  { name: 'II', description: 'II степень подвижности' },
  { name: 'III', description: 'III степень подвижности' },
  { name: 'Pt', description: 'Pt - периодонтит' },
  { name: 'И', description: 'И - искусственный зуб' },
];
/**
 * @description Условные обозначения.
 * @type {{name:string, description:string}[]}
 */
const diagnosisLegends = [
  { name: '0', description: 'отсутствует' },
  { name: 'П', description: 'пломбированный' },
  { name: 'R', description: 'корень' },
  { name: 'А', description: 'пародонтоз' },
  { name: 'C', description: 'кариес' },
  { name: 'К', description: 'коронка' },
  { name: 'P', description: 'пульпит' },
  { name: 'I,II,III', description: 'степень подвижности' },
  { name: 'Pt', description: 'периодонтит' },
  { name: 'И', description: 'искусственный зуб' },
];

/**
 * @description Локальная примесь адреса.
 * @type {any}
 */
const addressLocalMixin = {
  computed: {
    addressTypeInputError: resolveInputErrors('address.address-type'),
    apartmentInputError: resolveInputErrors('address.apartment'),
    buildingInputError: resolveInputErrors('address.building'),
    cityInputError: resolveInputErrors('address.city'),
    districtInputError: resolveInputErrors('address.district'),
    postalCodeInputError: resolveInputErrors('address.postal-code'),
    streetInputError: resolveInputErrors('address.street'),
  },
  data() {
    return {
      /**
       * @description Адрес.
       * @type {Address}
       */
      address: new Address(),
      /**
       * @description Адрес изменен.
       * @type {boolean}
       */
      isAddressChanged: false,
    };
  },
  methods: {
    /**
     * @description Отправить запрос на редактирование адреса.
     * @returns {Promise<Validation>}
     */
    sendAddressEditRequest() {
      const onSuccess = () => {
        this.address.refresh();
        this.isAddressChanged = false;
      };
      const request = new EditAddressRequest(this.address, this.patientId);
      return this
        .$patientGateway
        .editAddress(request)
        .then((result) => {
          result.forEach(onSuccess);
          return result.toValidation();
        });
    },
  },
  watch: {
    address: {
      handler: debounce(function update(value) {
        this.isAddressChanged = value.isChanged();
      }, WAIT_TIME),
      deep: true,
    },
  },
};

export default {
  formatsPrint,
  components: {
    PopoverMenu,
    InputTypedPhone,
    FormIdentification,
    AvailableSection,
    ConfirmSideDialog,
    FormPatientContacts,
    FormPatientMedcardEdit,
    InputCheckbox,
    InputDate,
    InputSnils,
    InputText,
    ModalDialog,
    ModalDialogPreventLeave,
    PatientLabels,
    PatientProfile,
    PatientSection,
    PatientSectionControl,
    SideSlideTransition,
    TheSelect,
  },
  computed: {
    /**
     * @description Данные для редактирования профиля сотрудника.
     * @type {any}
     */
    patientOptions({ patientEditOptions, fetchPatientOptions }) {
      return patientEditOptions.orLazy(fetchPatientOptions);
    },
    /**
     * @description Рекламные каналы.
     * @type {AdvertisingChannel[]}
     */
    advertisingChannels({ advertisingChannelList, advertisingChannelId, advertisingChannelName }) {
      if (advertisingChannelId !== -1) {
        return [...advertisingChannelList, {
          id: advertisingChannelId,
          name: advertisingChannelName,
        }];
      }
      return advertisingChannelList;
    },
    birthDate({ medcard }) {
      if (medcard.birthDate) {
        const date = new Date(medcard.birthDate);
        return `${formatDate(date)} (${medcard.age})`;
      }
      return '';
    },
    /**
     * @description Может инициировать звонки.
     * @returns {boolean}
     */
    canInitiateCall() {
      return this.actions.includes(ACTION_INITIATE_CALLS);
    },
    /**
     * @description Дата начала ведения медкарты пациента.
     * @type {string}
     */
    cardCreatedAt({ medcard }) {
      if (medcard.medicalCardCreatedAt) {
        return formatDate(new Date(medcard.medicalCardCreatedAt));
      }
      return '';
    },
    /**
     * @description Индекс раскрываемого раздела пациента для ЕГИСЗ.
     */
    egiszPatientSectionIndex() {
      return Object
        .entries(this.$refs)
        .flatMap(([name]) => (name.startsWith('patientSectionOf') ? [name] : []))
        .indexOf('patientSectionOfEgisz');
    },
    /**
     * @description Индекс раскрываемого раздела пациента контакты.
     */
    contactPatientSectionIndex() {
      return Object
        .entries(this.$refs)
        .flatMap(([name]) => (name.startsWith('patientSectionOf') ? [name] : []))
        .indexOf('patientSectionOfContacts');
    },
    /**
     * @description Показывать контакты пациента и адрес.
     * @returns {boolean}
     */
    isShowContact() {
      return this.actions.includes('view-patient-contacts');
    },
    /**
     * @description Имя и фамилия пациента.
     * @type {string}
     */
    patientName: ({ medcard }) => `${medcard.surname} ${medcard.name} ${medcard.patronymic}`,
    /**
     * @description Идентификатор пациента.
     * @type {number}
     */
    patientId: (vm) => parseInt(vm.$route.params.id, 10),
    addressInputError: resolveInputErrors('identification.address'),
    departmentCodeInputError: resolveInputErrors('identification.departmentCode'),
    guardianAddressInputError: resolveInputErrors('guardian-address'),
    guardianBirthDateError: resolveInputErrors('guardian-birth-date'),
    guardianIdentificationNumberError: resolveInputErrors('guardian-identification-number'),
    guardianIdentificationSerialError: resolveInputErrors('guardian-identification-serial'),
    guardianIdentificationTypeError: resolveInputErrors('guardian-identification-type'),
    guardianIdentificationWhenIssuedError: resolveInputErrors('guardian-identification-when-issued'),
    guardianIdentificationWhoIssuedError: resolveInputErrors('guardian-identification-who-issued'),
    guardianInnInputError: resolveInputErrors('guardian-identification-inn'),
    guardianSnilsInputError: resolveInputErrors('identification.snils'),
    guardianPhoneInputError: resolveInputErrors('guardian-phone'),
    guardianDepartmentCodeInputError: resolveInputErrors('guardian-identification-department-code'),
    guardianNameError: resolveInputErrors('guardian-name'),
    guardianPatronymicError: resolveInputErrors('guardian-patronymic'),
    guardianRelationError: resolveInputErrors('guardian-relationship-type'),
    guardianRepresentDocumentError: resolveInputErrors('guardian-represent-document'),
    guardianSurnameError: resolveInputErrors('guardian-surname'),
    identificationTypeInputError: resolveInputErrors('identification.type'),
    livingAddressInputError: resolveInputErrors('identification.livingAddress'),
    numberInputError: resolveInputErrors('identification.number'),
    serialInputError: resolveInputErrors('identification.serial'),
    snilsInputError: resolveInputErrors('documents.snils'),
    whenIssuedInputError: resolveInputErrors('identification.when_issued'),
    whoIssuedInputError: resolveInputErrors('identification.who_issued'),
    /**
     * @description Предотвращать уход со страницы.
     * @type {boolean}
     */
    needPreventLeave(vm) {
      return vm.isAddressChanged
      || vm.isContactsChanged
      || vm.needSaveDocuments
      || vm.isIdentificationChanged
      || vm.isGuardianChanged
      || vm.needSaveIndividualData;
    },
    /**
     * @description Нужно сохранение документов.
     */
    needSaveDocuments() {
      return this.isDocumentsChanged && this.shownEgiszSection;
    },
    /**
     * @description Нужно сохранение личных данных.
     */
    needSaveIndividualData() {
      return this.individualData.hasEgiszDataRefusal
        ? this.isEgiszDataRefusalChanged
        : this.isIndividualDataChanged;
    },
    isSaveDisabled: ({ isAwaitRequest, needPreventLeave }) => !needPreventLeave || isAwaitRequest,
    /**
     * @description Черты пациентов.
     * @type {{id:string, name:string}[]}
     */
    labels: ({ fetchPatientLabels, labelList }) => labelList.orLazy(fetchPatientLabels),
    /**
     * @description Показывать блок ЕГИСЗ.
     */
    shownEgiszSection() {
      return this.individualData.hasEgiszDataRefusal !== true || this.hasEgisz !== true;
    },
  },
  async created() {
    this.isSectionLoaded = false;
    this.isAwaitRequest = true;
    this.fetchGuardiansList(this.patientId);
    this.fetchAdvertisingChannelList();
    this.fetchPatientOptions();
    const either = await this.$patientGateway.viewBasic(this.patientId);
    either.forEach(
      ({
        actions,
        addresses,
        advertisingChannel,
        contacts,
        documents,
        guardians,
        identification,
        iemkStatus,
        individualData,
        medcard,
        snilsRequired,
        hasEgisz,
        basicFieldsErrors,
        medcardFieldsErrors,
        egiszDataRefusalSampleDocumentTemplateId,
      }) => {
        this.actions = actions;
        if (addresses.length > 0) {
          [this.address] = addresses;
        }
        this.advertisingChannelId = advertisingChannel.id;
        this.advertisingChannelName = advertisingChannel.name;
        this.contacts = new PatientContacts(
          contacts.getEmail(),
          contacts.isAllowedSms(),
          contacts.isNoCalls(),
          contacts.getPhoneList(),
        );
        this.initialContacts = this.contacts;
        this.documents = documents;
        this.egiszDataRefusalSampleDocumentTemplateId = egiszDataRefusalSampleDocumentTemplateId;
        this.guardians = guardians;
        this.identification = identification;
        this.iemkStatus = iemkStatus.getId();
        this.iemkStatusDescription = iemkStatus.getText();
        this.individualData = individualData;
        this.medcard = medcard;
        this.getFirstGuardian();
        this.snilsRequired = snilsRequired;
        this.hasEgisz = hasEgisz;
        const basicFailurePairs = (basicFieldsErrors.causes || [])
          .map((cause) => [cause.source, cause.details]);
        const medcardFailurePairs = (medcardFieldsErrors.causes || [])
          .map((cause) => [cause.source, cause.details]);
        this.inputErrors = Object.fromEntries(basicFailurePairs) || {};
        const failureForIdentification = this.mapIdentificationFails(basicFieldsErrors.causes);
        Object.assign(
          this.inputErrorsIdentification,
          Object.fromEntries(failureForIdentification) || {},
        );
        this.medcardInputErrors = Object.fromEntries(medcardFailurePairs) || {};
      },
    );
    either.forEachFail((response) => {
      this.notifyFail(response.title);
    });
    await this.fetchDefaultMedcardNumber();
    this.isSectionLoaded = true;
    this.isAwaitRequest = false;
  },
  data() {
    return {
      isShownPrintDialog: false,
      formatPrint: 'A4',
      /**
       * @description Допустимые действия.
       * @type {string[]}
       */
      actions: [],
      patientEditOptions: Maybe.none(),
      /**
       * @description Адрес.
       * @type {Address}
       */
      address: new Address(),
      /**
       * @description Список рекламных каналов.
       * @type {AdvertisingChannel[]}
       */
      advertisingChannelList: [],
      /**
       * @description Идентификатор рекламного канала.
       * @type {string}
       */
      advertisingChannelId: -1,
      /**
       * @description Название рекламного канала.
       * @type {string}
       */
      advertisingChannelName: '',
      /**
       * @description Форма открыта.
       * @type {boolean}
       */
      hasOpenForm: false,
      /**
       * @description Открытые секции.
       * @type {number[]}
       */
      sectionVisibly: [],
      /**
       * @description Контактные данные пациента.
       * @type {PatientContacts}
       */
      contacts: new PatientContacts(),
      /**
       * @description Нарушения ограничений контактов.
       * @type {Object}
       */
      contactsViolationCauses: {},
      /**
       * @description Номер медкарты пациента по умолчанию.
       * @type {string}
       */
      defaultMedcardNumber: '',
      /**
       * @description Документы.
       * @type {Documents}
       */
      documents: new Documents(),
      /**
       * @description Первичная проверка полей ввода на отправку данных.
       * @type {boolean}
       */
      hasPrimaryReportValidity: true,
      /**
       * @description Удостоверение личности.
       * @type {Identification}
       */
      identification: new Identification(),
      /**
       * @description Код статуса отчетности в ИЭМК ЕГИСЗ.
       * @type {string}
       */
      iemkStatus: '',
      /**
       * @description Пояснение статуса отчетности в ИЭМК ЕГИСЗ.
       * @type {string}
       */
      iemkStatusDescription: '',
      /**
       * @description Нарушение ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Секция загружена.
       * @type {Boolean}
       */
      isSectionLoaded: false,
      /**
       * @description Медкарта.
       * @type {Medcard}
       */
      medcard: new Medcard(),
      /**
       * @description Нарушение ограничений при редактировании медкарты.
       * @type {any}
       */
      medcardInputErrors: {},
      /**
       * @description Контакты изменены.
       * @type {boolean}
       */
      isContactsChanged: false,
      /**
       * @description Документы изменены.
       * @type {boolean}
       */
      isDocumentsChanged: false,
      /**
       * @description Удостоверение личности изменено.
       * @type {boolean}
       */
      isIdentificationChanged: false,
      /**
       * @description Список меток.
       * @type {Maybe}
       */
      labelList: Maybe.None(),
      /**
       * @description Необходимо подтверждение перед закрытием формы.
       * @type {boolean}
       */
      needConfirmBeforeClosed: false,
      phoneList: [],
      initialContacts: new PatientContacts(),
      /**
       * @description Обязательно заполнения СНИЛС.
       * @type {boolean}
       */
      snilsRequired: true,
      /**
       * @description Имеется доступ к ЕГИСЗ
       * @type {boolean}
       */
      hasEgisz: false,
      /**
       * @description Ошибки для удостоверения личности представителя
       * @type {any}
       */
      inputErrorsGuardianIdentification: {},
      /**
       * @description Ошибки для удостоверения личности
       * @type {any}
       */
      inputErrorsIdentification: {},
    };
  },
  methods: {
    /**
     * @description Обновление удостоверения личности
     * @param newIdentification {Identification}
     */
    onUpdateIdentification(newIdentification) {
      this.identification = newIdentification;
    },
    /**
     * @description Обработать расширение секции для данных ЕГИСЗ.
     * @returns {void}
     */
    highlightInvalidFieldsIntoEgiszSection() {
      if (this.hasPrimaryReportValidity !== true) {
        return;
      }
      this.hasPrimaryReportValidity = false;
      const index = this.egiszPatientSectionIndex;
      this.sectionVisibly.push(index);
      setTimeout(() => { this.$refs.patientFormRef.reportValidity(); }, WAIT_TIME);
    },
    /**
     * @description Обработать расширение секции для данных контактов.
     * @returns {void}
     */
    highlightInvalidFieldsIntoContactSection() {
      if (this.hasPrimaryReportValidity !== true) {
        return;
      }
      this.hasPrimaryReportValidity = false;
      const index = this.contactPatientSectionIndex;
      this.sectionVisibly.push(index);
      setTimeout(() => { this.$refs.patientFormRef.reportValidity(); }, WAIT_TIME);
    },
    /**
     * @description Обработать ввод контактов.
     * @param {PatientContacts} value
     * @returns {void}
     */
    onInputContacts: debounce(
      function _(value) {
        this.contacts = value;
        this.isContactsChanged = this.initialContacts.toString() !== value.toString();
      },
      WAIT_TIME,
    ),
    /**
     * @description Скопировать адрес прописки в адрес проживания
     */
    copyAddressToLivingAddress() {
      this.identification.livingAddress = this.identification.address;
    },
    fetchPatientOptions() {
      const defaultOptions = {
        addressTypeList: [],
      };
      const onResponse = (result) => {
        result.fold(defaultOptions)(({ addressTypeList }) => {
          const addressTypes = addressTypeList
            .map((item) => ({ title: item.name, value: item.id }));
          this.patientEditOptions = Maybe.some({ addressTypeList: addressTypes });
        });
      };
      this
        .$suggestionGateway
        .getPatientCreation()
        .then((onResponse));
      return defaultOptions;
    },
    async fetchDefaultMedcardNumber() {
      const either = await this.$patientGateway.getDefaultPatientMedcardNumber();
      either.forEach((defaultMedcardNumber) => {
        this.defaultMedcardNumber = defaultMedcardNumber;
      });
      either.forEachFail((response) => {
        this.notifyFail(response.title);
      });
    },
    /**
     * @description Обработать изменение значений полей формы.
     * @param {string}  form     Название формы.
     * @param {boolean} isChange Есть изменения.
     * @returns {void}
     */
    onChangeFieldValues(form, isChange) {
      this.needConfirmBeforeClosed = isChange;
    },
    /**
     * @description Получить список рекламных каналов.
     * @returns {void}
     */
    fetchAdvertisingChannelList() {
      this
        .$advertisingChannelGateway
        .viewList()
        .then((either) => {
          this.advertisingChannelList = either.fold(() => [], ({ list }) => list);
        });
    },
    fetchPatientLabels() {
      this.$patientGateway.viewLabels().then((list) => {
        this.labelList = Maybe.Some(list);
      });
    },
    /**
     * @description Обработать изменение рекламного канала.
     * @param {number} id Идентификатор рекламного канала.
     * @returns {void}
     */
    onEditAdvertisingChannels(id) {
      const onFail = ({ title }) => { this.notifyFail(title); };
      const onSuccess = ({ message }) => {
        this.notifySuccess(message);
        this.advertisingChannelId = id;
        this.advertisingChannelName = this.advertisingChannels.find((item) => item.id === id).name;
      };
      this.$patientGateway.setAdvertisingChannel(this.patientId, id).then((either) => {
        either.fold(onFail, onSuccess);
      });
    },
    openEditForm() {
      this.hasOpenForm = true;
    },
    /**
     * @description Отправить запрос на изменение контактов.
     * @returns {Promise<Validation>}
     */
    async sendContactsEditRequest() {
      const request = new EditPatientContactsRequest(this.contacts, this.patientId);
      const result = await this.$patientGateway.editContacts(request);
      result.forEach(() => {
        this.contactsViolationCauses = {};
        this.initialContacts = this.contacts;
        this.isContactsChanged = false;
      });
      result.forEachFail((error) => {
        this.contactsViolationCauses = Object.fromEntries(
          error.causes.map((cause) => [cause.source, cause.details]) || {},
        );
      });
      return result;
    },
    /**
     * @description Отправить запрос на изменение документов.
     * @returns {Promise<Validation>}
     */
    async sendDocumentsEditRequest() {
      const request = new EditPatientDocumentsRequest(this.documents, this.patientId);
      const result = await this.$patientGateway.editDocuments(request);
      result.forEach(() => {
        this.documents.refresh();
        this.isDocumentsChanged = false;
      });
      return result;
    },
    /**
     * @description Отправить запрос на изменение удостоверения личности.
     * @returns {Promise<Validation>}
     */
    async sendIdentificationEditRequest() {
      const request = new EditPatientIdentificationRequest(this.identification, this.patientId);
      const result = await this.$patientGateway.editIdentification(request);
      result.forEach(() => {
        this.identification.refresh();
        this.isIdentificationChanged = false;
      });
      return result;
    },
    /**
     * @description Отправить запрос на изменение удостоверения личности по иностранному паспорту.
     * @returns {Promise<Validation>}
     */
    async sendIdentificationForeignPasswordEditRequest() {
      const request = new EditPatientIdentificationForeignPasswordRequest(
        this.identification,
        this.patientId,
      );
      const result = await this.$patientGateway.editIdentification(request);
      result.forEach(() => {
        this.identification.refresh();
        this.isIdentificationChanged = false;
      });
      return result;
    },
    /**
     * @description Обработать сохранение данных пациента.
     * @returns {Promise<Validation>}
     */
    onSavePatient() {
      this.hasPrimaryReportValidity = true;
      const isNativeValidationSuccess = this.$refs.patientFormRef.reportValidity();
      if (isNativeValidationSuccess !== true) {
        this.notifyFail('Не удалось отправить данные, проверьте правильность заполнения');
        return Promise.resolve(Validation.Fail());
      }
      const requests = [];
      if (this.isAddressChanged) {
        requests.push(this.sendAddressEditRequest());
      }
      if (this.isContactsChanged) {
        requests.push(this.sendContactsEditRequest());
      }
      if (this.isIdentificationChanged) {
        if (this.identification.type === 'foreign-passport') {
          requests.push(this.sendIdentificationForeignPasswordEditRequest());
        } else {
          requests.push(this.sendIdentificationEditRequest());
        }
      }
      if (this.needSaveDocuments) {
        requests.push(this.sendDocumentsEditRequest());
      }
      if (this.isGuardianChanged) {
        requests.push(this.sendGuardianEditRequest());
      }
      if (this.needSaveIndividualData) {
        requests.push(this.sendEditPatientIndividualDataRequest());
      }
      this.isAwaitRequest = true;
      return Promise.all(requests).then((orderedResults) => {
        this.inputErrors = {};
        this.inputErrorsIdentification = {};
        let isSuccess = true;
        orderedResults.forEach((result) => {
          /** response {causes: [], title: String} */
          result.forEachFail((response) => {
            isSuccess = false;
            if (!response.causes) {
              return;
            }
            const failurePairs = response.causes.map((cause) => [cause.source, cause.details]);
            const failureForIdentification = this.mapIdentificationFails(response.causes);
            if (failurePairs.length !== 0) {
              this.notifyFail(response.title);
            }
            Object.assign(this.inputErrors, Object.fromEntries(failurePairs) || {});
            Object.assign(
              this.inputErrorsIdentification,
              Object.fromEntries(failureForIdentification) || {},
            );
          });
        });
        this.isAwaitRequest = false;
        if (isSuccess) {
          this.notifySuccess('Данные успешно обновлены');
          return Validation.Success('Данные успешно обновлены');
        }
        return Validation.Fail();
      });
    },
    /**
     * @description Обработать сохранение представителя пациента.
     * @returns {void}
     */
    onSavePatientGuardian() {
      const isNativeValidationSuccess = this.$refs.patientGuardianFormRef.reportValidity();
      if (isNativeValidationSuccess !== true) {
        this.notifyFail('Не удалось отправить данные представителя, проверьте правильность заполнения');
      } else {
        const request = this.sendGuardianEditRequest();
        Promise.resolve(request).then((result) => {
          this.inputErrors = {};
          this.inputErrorsGuardianIdentification = {};
          result.forEach(({ title }) => { this.notifySuccess(title); });
          result.forEachFail((response) => {
            if (!response.causes) {
              return;
            }
            const failurePairs = response.causes.map((cause) => [cause.source, cause.details]);
            const failureIdentification = this.mapIdentificationFails(response.causes);
            if (failurePairs.length !== 0) {
              this.notifyFail(response.title);
            }
            Object.assign(this.inputErrors, Object.fromEntries(failurePairs) || {});
            Object.assign(
              this.inputErrorsGuardianIdentification,
              Object.fromEntries(failureIdentification) || {},
            );
          });
        });
      }
    },
    /**
     * @description Мапим ошибки для удостоверения личности
     *
     * @param causes {array}
     * @return {array}
     */
    mapIdentificationFails(causes) {
      return causes.map((cause) => {
        if (cause.source.includes('identification')) {
          return [cause.source, cause.details];
        }
        return [];
      });
    },
    async saveAndLeave() {
      const result = await this.onSavePatient();
      result.forEach((message) => {
        this.notifySuccess(message);
        this.actionAfterClosingDialogLeaveConfirm();
      });
      this.isShownDialogLeaveConfirm = false;
    },
    /**
     * @description Обработать изменение медкарты пациента.
     * @param {Medcard} medcard
     * @returns {void}
     */
    async onChangeMedcard(medcard) {
      if (this.isAwaitRequest) {
        return;
      }
      this.isAwaitRequest = true;
      const request = new EditPatientMedcardRequest(medcard, this.patientId);
      const either = await this.$patientGateway.editMedcard(request);
      either.forEach((message) => {
        this.notifySuccess(message);
        this.medcardInputErrors = {};
        this.medcard = medcard;
        this.hasOpenForm = false;
        this.$patientGateway.getPatientName(this.patientId).then((result) => {
          result.forEach((patient) => {
            this.$store.commit(PATIENT_PROFILE, patient);
          });
        });
      });
      either.forEachFail((response) => {
        const failurePairs = response.causes.map((cause) => [cause.source, cause.details]);
        this.medcardInputErrors = Object.fromEntries(failurePairs) || {};
      });
      this.isAwaitRequest = false;
    },
    /**
     * @description Распечатать медкарту.
     * @returns {void}
     */
    printMedcard() {
      const getSurnameWithInitials = (fullName) => {
        let result = '';
        const [surname, name, patronymic] = fullName.split(' ');
        if (surname) {
          result += surname;
        }
        if (name) {
          result += ` ${name.substring(0, 1)}`;
        }
        if (patronymic) {
          result += ` ${patronymic.substring(0, 1)}`;
        }
        return result;
      };
      const onSuccess = (response) => {
        const blob = new Blob([response], { type: 'text/html' });
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(blob));
        container.onload = () => {
          const documentTitle = document.title;
          document.title = getSurnameWithInitials(this.patientName);
          container.contentWindow.addEventListener('afterprint', () => {
            document.title = documentTitle;
          }, { once: true });
          container.contentWindow.print();
        };
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this.printMedcardReachGoal();
      this.$patientGateway.viewMedcardForPrint(this.patientId, this.formatPrint).then((result) => {
        result.fold(onFail, onSuccess);
      }).finally(() => {
        this.isShownPrintDialog = false;
      });
    },
    /**
     * @description Обработать достижение цели печати медкарты.
     * @returns {void}
     */
    printMedcardReachGoal() {
      if (this.formatPrint === 'A5') {
        this.$goal(GOAL_PRINT_MEDCART_A5);
      }
    },
  },
  bloodTypes,
  disabilityTypes,
  diagnosisList,
  diagnosisLegends,
  maxTextLength: 20000,
  rpFactors,
  name: 'ClinicPanelPatientBasic',
  mixins: [
    GuardianMixin,
    addressLocalMixin,
    callMixin,
    individualDataMixin,
    notifierMixin,
    preventLeaveWithoutConfirmMixin,
    mobileMixin,
  ],
  watch: {
    documents: {
      handler: debounce(function update(value) {
        this.isDocumentsChanged = value.isChanged();
      }, WAIT_TIME),
      deep: true,
    },
    identification: {
      handler: debounce(function update(value) {
        this.isIdentificationChanged = value.isChanged();
      }, WAIT_TIME),
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";

.patient-refusal-modal {
  .modal-dialog {
    .v-card__title {
      max-width: none;
    }
    .v-card__text {
      row-gap: 20px;
    }
    &__buttons {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      gap: 10px;
    }
    &__cancel {
      @include buttons.btn-transparent(100%, 40px, 16px);
      max-width: 230px;
    }
    &__agree {
      @include buttons.btn-blue(100%, 40px, 16px);
      max-width: 230px;
    }
  }
}

.patient-iemk-status {
  display: flex;
  align-items: center;
  padding: 10px;
  &.fail,
  &.success,
  &.none {
    border-right: 1px solid #c2cfe0;
    border-left: 1px solid #c2cfe0;
    &:before {
      content: '';
      height: 20px;
      min-height: 20px;
      margin-right: 10px;
      width: 20px;
      min-width: 20px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
  &.fail {
    background-color: #FFECEC;
    &:before {
      background-image: url("@/assets/img/exit-red.svg");
    }
  }
  &.success {
    background-color: #E4FFEC !important;
    &:before {
      background-image: url("@/assets/img/checked/all-checked-green.svg");
    }
  }
  &.none:before {
    height: 6px;
    min-width: 6px;
    width: 6px;
    min-height: 6px;
    background: #ABB1A3;
    border-radius: 50%;
    margin: 0 10px 0 6px;
  }
}

.patient-print {
  display: none;
}

.print-medcard-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  &__document {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    &__count {
      display: flex;
      align-items: center;
      column-gap: 5px;
      input {
        border-bottom: 1px solid #C2CFE0;
        box-sizing: border-box;
        appearance: textfield;
        text-align: center;
        height: 30px;
        width: 30px;
        margin: 0 7px;
        color: #707683;
        font-size: 14px;
        &:focus {
          color: #192a3e;
          background-color: #fff;
          border-bottom: 1px solid #0489e0 !important;
          outline: 0;
        }
        &:disabled {
          background-color: #fff;
        }
      }
    }
  }
  &__button {
    @include buttons.btn-blue(100%, 40px, 16px);
    align-self: center;
    max-width: 150px;
  }
}

.patient-basic {
  display: flex;
  flex-direction: column;
  width: 100%;
  &__caption {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #192a3e;
  }
  &__button-save {
    @include buttons.btn-blue(100%, 48px, 16px);
    max-width: 174px;
    padding: 0;
    margin: 10px 0 0 0;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__mark-alert {
    font-size: 1.25rem;
    font-weight: 600;
    color: #f21e1e;
  }
  &__medical-card {
    border: 1px solid #c2cfe0;
    border-radius: 0 !important;
    padding: 23px 17px 40px 30px;
    margin: 0 0 26px 0;
    &__advertising-row {
      display: grid;
      grid-template-columns: 190px 150px;
      grid-column-gap: 15px;
      align-items: center;
      margin: 5px 0 0 0;
      & > .v-autocomplete {
        margin-top: -10px !important;
        min-width: max-content;
      }
    }
    &__row {
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: center;
      justify-content: flex-start;
    }
    p {
      display: block;
      color: #192a3e;
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
      margin: 0;
    }
    &__buttons {
      display: flex;
      flex-direction: row;
      gap: 13px;
      justify-content: space-between;
      max-width: 362px;
    }
    &__button {
      &-print {
        @include buttons.btn-transparent(100%, 48px, 16px);
        flex: 1 1 auto;
        max-width: 174px;
        min-width: 142px;
        padding: 0;
        margin: 0;
        &:before {
          content: "";
          background-image: url("@/assets/img/print.svg");
          background-repeat: no-repeat;
          background-size: contain;
          width: 24px;
          height: 24px;
          margin: 0 8px 0 0;
        }
        &:disabled {
          color: var(--unfocus-color);
        }
      }
      &-save {
        @include buttons.btn-blue(100%, 48px, 16px);
        flex: 1 1 auto;
        max-width: 174px;
        min-width: 142px;
        padding: 0;
        margin: 0;
        &:disabled {
          background-color: var(--unfocus-color);
        }
      }
    }
    &__info {
      align-items: flex-start;
      display: flex;
      flex-direction: row;
      gap: 14px;
      margin-top: 18px;
      &-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 68px;
        min-width: 68px;
        height: 68px;
        min-height: 68px;
        border: 1px solid #abd576;
        border-radius: 50%;
        color: #abd576;
        background: #ebfbd8;
        text-align: center;
        font-weight: 800;
        font-size: 30px;
      }
      &-birth {
        color: #90a0b7;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
      }
      &-row {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      &__column {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      &-name {
        color: #192a3e;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
      }
      &-edit {
        background-image: url("@/assets/img/pen-grey.svg");
        background-size: contain;
        background-repeat: no-repeat;
        width: 15px;
        min-width: 15px;
        height: 15px;
        min-height: 15px;
        padding: 0;
        margin-left: 14px;
        cursor: pointer;
        &:hover {
          background-image: url("@/assets/img/pen-blue.svg");
        }
      }
      &-sourse {
        color: #192a3e;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
      }
    }
    &__note {
      color: var(--reading-color);
      font-size: 14px;
      line-height: 17px;
    }
    &__member {
      margin: 20px 0 0 0;
      font-weight: 600;
      color: var(--action-color);
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__sections {
    z-index: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 13px;
  }
  &__representative {
    flex-direction: column;
    display: flex;
    gap: 27px;
    &__identification-form {
      width: 100%;
      padding-right: 20%;
    }
    &__row {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 110px;
      grid-gap: 11px;
      &.document {
        grid-template-columns: 85px 115px 115px;
      }
    }
    &__gender {
      display: flex;
      flex-flow: row wrap;
      align-items: flex-start;
      row-gap: 11px;
      column-gap: 25px;
      font-size: 16px;
      line-height: 24px;
    }
    &__radio>input {
      position: absolute;
      z-index: -1;
      opacity: 0;
    }
    &__radio>span {
      display: inline-flex;
      align-items: center;
      user-select: none;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      cursor: pointer;
    }
    &__radio>span::before {
      content: '';
      display: inline-block;
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      flex-grow: 0;
      border: 1px solid #90A0B7;
      border-radius: 50%;
      margin-right: 10px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 50% 50%;
    }
    &__radio>input:not(:disabled):not(:checked)+span:hover::before {
      border: 1px solid #0489E0;
    }
    &__radio>input:checked+span::before {
      border: 1px solid #0489E0;
      background-color: #0489E0;
      box-shadow: inset 0 0 0 6px #fff;
    }
    &__block {
      max-width: 412px;
    }
    &__select {
      position: relative;
      width: 720px;
      max-width: 100%;
    }
    &__modal {
      &__buttons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 20px;
        margin: 20px 0 0 0;
      }
      &__button {
        @include buttons.btn-transparent(10rem, 2rem, 1rem);
        &.negative {
          margin-left: 9px;
          border: 1px solid rgba(224, 4, 4, 0.97);
          color: rgba(224, 4, 4, 0.97);
        }
      }
    }
    &__button {
      @include buttons.btn-transparent(100%, 48px, 16px);
      max-width: 265px;
      &:before {
        content: "";
        background-image: url("@/assets/img/exit-blue.svg");
        background-repeat: no-repeat;
        background-size: contain;
        width: 14px;
        height: 14px;
        margin: 0 12px 0 0;
      }
      &:disabled {
        background-color: var(--unfocus-color);
      }
    }
  }
  &__documents {
    flex-direction: column;
    display: flex;
    max-width: 740px;
    gap: 20px;
    &__row {
      display: grid;
      grid-template-columns: 333px 236px;
      grid-gap: 11px;
      &.serial {
        grid-template-columns: 95px 161px 1fr;
        max-width: 720px;
      }
    }
    &__copy {
      &__button {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        margin: 0 0 2px 0;
        color: var(--unfocus-color);
        &:after {
          content: '';
          background-image: url("@/assets/img/copy-blue.svg");
          background-repeat: no-repeat;
          background-position: bottom;
          background-size: contain;
          margin: 0 0 0 10px;
          width: 15px;
          height: 15px;
        }
      }
    }
    &__invalid {
      color: var(--warning-color);
      font-size: 12px;
      font-weight: 400;
      padding: 0.125rem;
      margin-bottom: 0;
    }
    &__select {
      position: relative;
      width: min(100%, 400px);
      &-input {
        padding: 0 42px;
        background: #ffffff;
        border: 1px solid #c2cfe0 !important;
        border-radius: var(--input-border-radius);
        outline: none;
        height: 40px;
        appearance: none;
        font-size: 16px;
        color: #192a3e;
        font-weight: 400;
        position: relative;
        width: 720px;
        max-width: 100%;
        cursor: pointer;
        &:focus {
          color: #192a3e;
          background-color: #fff;
          outline: 2px solid #0489e0;
        }
        &:disabled {
          background-color: #fff;
        }
      }
      &-icon-search {
        position: absolute;
        left: 12px;
        top: 10px;
        background-repeat: no-repeat;
        background-image: url("@/assets/img/search-black.svg");
        background-size: contain;
        width: 20px;
        height: 18px;
      }
      &-icon-file {
        position: absolute;
        right: 1px;
        top: 1px;
        background-repeat: no-repeat;
        background-image: url("@/assets/img/file.svg");
        background-position: center;
        background-color: #eaeff3;
        border-radius: 0 3px 3px 0;
        width: 36px;
        height: 38px;
      }
    }
    &-snils {
      width: 333px;
    }
    &-belay {
      width: 720px;
      &.indent {
        margin: -7px 0 -25px 0;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .patient-iemk-status {
    &.fail,
    &.success,
    &.none {
      border-top: 1px solid #c2cfe0;
    }
  }
}

@media screen and (max-width: 970px) {
  .patient-basic {
    &__documents {
      &-belay,
      &-snils,
      &-date {
        width: 100%;
      }
      &__row {
        grid-template-columns: 1fr;
        grid-gap: 27px;
        &.serial {
          grid-template-columns: 1fr;
        }
      }
    }
    &__row {
      grid-template-columns: 1fr;
    }
  }
}

@media screen and (max-width: 720px) {
  .patient-basic {
    &__representative {
      &__row.fio {
        grid-template-columns: 1fr;
      }
    }
    &__medical {
      &-card {
        &__advertising {
          &-row {
            grid-template-columns: 1fr;
            margin: 10px 0 0 0;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .patient {
    &-basic {
      &__medical {
        &-card {
          padding: 20px 15px;
          &__info {
            flex-direction: column;
            align-items: flex-start;
          }
          &__buttons {
            max-width: 230px;
            flex-direction: column;
          }
          &__button {
            &-print {
              display: none;
            }
            &-save {
              max-width: 100%;
            }
          }
        }
      }
      &__representative {
        &__row {
          &.document {
            grid-template-columns: 1fr;
          }
        }
      }
    }
  }
}
</style>
